export class PreferenceValidationError extends Error {
  constructor(
    message: string,
    public field: string,
    public value: any,
    public rule?: string
  ) {
    super(message);
    this.name = 'PreferenceValidationError';
  }
}

export type ValidationErrorDetail = {
  field: string;
  value: any;
  message: string;
  rule?: string;
};

export class PreferenceValidationErrors extends Error {
  constructor(
    message: string,
    public errors: ValidationErrorDetail[]
  ) {
    super(message);
    this.name = 'PreferenceValidationErrors';
  }

  toString(): string {
    const errorList = this.errors
      .map((e, i) => `  ${i + 1}. [${e.field}] ${e.message} (value: ${JSON.stringify(e.value)}, rule: ${e.rule})`)
      .join('\n');

    return `${this.message}\n${errorList}`;
  }
}
